import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSnackBar} from '@angular/material';
import {ReturnReasonName} from '../../models/ReturnReasonName';

@Component({
  selector: 'app-return-reasons',
  styleUrls: ['./return-reasons.component.scss'],
  templateUrl: './return-reasons.component.html'
})
export class ReturnReasonsComponent implements OnInit {
  public editedReturnReasonName: string;
  public returnReasonDataSource: MatTableDataSource<ReturnReasonName>;
  public returnReasonNameColumns: string[] = ['name', 'actions'];
  public isReturnReasonEditable: boolean;
  public loading: boolean;
  public newName: string;
  private updateReturnReasonItem: any;

  constructor(private commonService: CommonService,
              private matSnackBar: MatSnackBar) {
    this.isReturnReasonEditable = false;
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    await this.getReturnReasonNames();
  }

  async addReturnReasonName() {
    if (this.newName) {
      try {
        const result = await this.commonService.insertObject('return_reason', {name: this.newName});
        this.toastMessages('Η αιτία δημιουργήθηκε με επιτυχία');
        const model = {
          id: result.id,
          name: this.newName,
          has_been_used: 0
        };
        const data = JSON.parse(JSON.stringify(this.returnReasonDataSource.data));
        data.push(model);
        this.returnReasonDataSource.data = data;
        this.resetReturnReasonName();
        this.toastMessages(`Η αιτία δημιουργήθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Αποτυχία δημιουργίας. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενό');
    }
  }

  applyFilterReturnReasonNames(value: any): void {
    this.returnReasonDataSource.filter = value.trim().toLocaleLowerCase();
  }

  async deleteReturnReason(id: number, index: number) {
    try {
      await this.commonService.deleteRecord(`return_reason/${id}`);
      this.toastMessages('Η αιτία διαγράφηκε με επιτυχία');
      const data = JSON.parse(JSON.stringify(this.returnReasonDataSource.data));
      data.splice(index, 1);
      this.returnReasonDataSource.data = data;
    } catch (e) {
    }
  }

  editReturnReasonName(id: any, index: any): void {
    this.isReturnReasonEditable = true;
    this.editedReturnReasonName = this.returnReasonDataSource.data[index].name;
    this.updateReturnReasonItem = {
      id,
      index,
      name: this.returnReasonDataSource.data[index].name
    };
  }

  async getReturnReasonNames(): Promise<any> {
    try {
      this.loading = true;
      const data = await this.commonService.getSimpleList('return_reason') as ReturnReasonName[];
      this.returnReasonDataSource = new MatTableDataSource<ReturnReasonName>(data);
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  isDeleteReturnReasonDisabled(element: any): boolean {
    return element.has_been_used !== 0;
  }

  async updateReturnReasonName() {
    const data = JSON.parse(JSON.stringify(this.returnReasonDataSource.data));
    const updatedItem = data.find(item => item.id === this.updateReturnReasonItem.id);

    const model = {
      id: this.updateReturnReasonItem.id,
      name: this.editedReturnReasonName,
      has_been_used: updatedItem.has_been_used
    };

    if (this.editedReturnReasonName) {
      try {
        await this.commonService.updateObject(`return_reason/${model.id}`, {name: this.editedReturnReasonName});
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }

      const index = this.updateReturnReasonItem.index;
      data[index] = model;
      this.returnReasonDataSource.data = data;

      this.resetReturnReasonName();
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενο');
    }
  }

  resetReturnReasonName(): void {
    this.newName = '';
    this.updateReturnReasonItem = {};
    this.isReturnReasonEditable = false;
    this.editedReturnReasonName = '';
  }

  toastMessages(message: string): void {
    this.matSnackBar.open(message, '', {
      duration: 5000,
    });
  }
}
